import { isEmpty } from 'ramda'

import SimpleDate from 'app/common/classes/simple-date'
import { canMailingTo } from 'app/common/ui-next/_filter-compilations/mailing'
import { dateFormat as plainDatePeriodFormat } from 'app/common/ui-next/plain-date-period'

export type AverageCheckParamsDto = {
  report_type: string
  params: {
    from: string
    to: string
    limits: {
      school_ids: Array<number> // id школ
      sale_type?: 'personal' | 'complex' // тип продаж (личные, комплексное питание)
      building_id?: Array<number> // id здания
      sale_point_id?: Array<number> // id точки продаж
      food_mode?: Array<'breakfast' | 'dinner' | 'afternoon'>
    }
  }
  options?: {
    send_to_email?: string // отправить на почту
  }
}

const dateFormat = 'YYYY-MM-DD'

export const convertParams = (formData: FormData): [AverageCheckParamsDto, null] => {
  const from = formData.get('periodFrom') as string
  const to = formData.get('periodTo') as string
  const saleType = formData.get('saleType') as 'personal' | 'complex' | null
  const buildingIds = formData.getAll('building') as Array<string> | []
  const salePointIds = formData.getAll('salePoint') as Array<string> | []
  const foodMode = formData.getAll('foodMode') as Array<'breakfast' | 'dinner' | 'afternoon'> | []
  const orgIds = formData.getAll('org') as Array<string>
  const email = canMailingTo(formData)
  const options = email ? { send_to_email: email } : {}

  return [
    {
      report_type: 'average_check',
      params: {
        from: new SimpleDate(from, plainDatePeriodFormat).getStringFormatted(dateFormat),
        to: new SimpleDate(to, plainDatePeriodFormat).getStringFormatted(dateFormat),
        limits: {
          school_ids: orgIds.map((id) => Number(id)),
          sale_type: saleType || undefined,
          building_id: isEmpty(buildingIds) ? undefined : buildingIds.map((id) => Number(id)),
          sale_point_id: isEmpty(salePointIds) ? undefined : salePointIds.map((id) => Number(id)),
          food_mode: isEmpty(salePointIds) ? foodMode : [],
        },
      },
      options,
    },
    null,
  ]
}
